import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import { tenantService } from "../../Services/tenant.service";
import { useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";
import ResultModal from "../Common/ResultModal";
import { AuthContext } from "../../Contexts/AuthContext";
import { roles } from "../../Config/Roles";
import { numbersOnly } from "../../Config/Regex";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";

const TeantSettingTab = (props) => {
  const history = useHistory();
  const { roleId } = useContext(AuthContext);
  const { locTab } = useContext(GlobalContext);

  const { master, admin, support, owner } = roles;
  const [isDisabled, setDisable] = useState(true);
  const { handleSubmit, register, formState, errors } = useForm();
  const [update, setUpdate] = useState(new Date());
  const [settings, setSettings] = useState([]);
  const { t: translator } = useTranslation();
  const [modal, setModal] = useState({
    title: "",
    text: "",
    show: false,
    btnClass: "",
  });

  useEffect(() => {
    if (locTab === "settings") {
      tenantService
        .getTenantSetting(props.tenantId)
        .then((res) => {
          setSettings(res.data);
        })
        .catch((err) => console.log(err.response));
    }
  }, [update, locTab]);

  const handleCheckboxChange = (event) => {
    setDisable(false);
    const { name, checked } = event.target;
    setSettings({ ...settings, [name]: checked });
  };

  const onSubmit = (data) => {
    tenantService
      .updateTenantSetting({ settings, data })
      .then((res) => {
        res.data.success
          ? setModal({
              show: true,
              title: translator("TenantSettingTab-SuccesModal-Title"),
              text: translator("TenantSettingTab-SuccesModal-Text"),
              btnClass: "btn btn-primary",
            })
          : setModal({
              show: true,
              title: translator("TenantSettingTab-UnsuccesModal-Title"),
              text: translator("TenantSettingTab-UnsuccesModal-Text"),
              btnClass: "btn btn-primary",
            });
      })
      .catch((err) =>
        setModal({
          show: true,
          title: translator("TenantSettingTab-UnsuccesModal-Title"),
          text: translator("TenantSettingTab-UnsuccesModal-Text"),
          btnClass: "btn btn-primary",
        })
      );
  };

  const handleClose = () => {
    setModal({ show: false });
    setDisable(true);
    setUpdate(new Date());
  };

  return (
    <div className="p-2">
      <div className="container-fluid p-0">
        <div className="card-body pl-0 mb-4">
          <form onSubmit={handleSubmit(onSubmit)} className="row">
            <div className="col-lg-6">
              <fieldset className="scheduler-border">
                <div className="form-group col-12">
                  <label className="labelCont">
                    <input
                      type="checkbox"
                      name="cashDefault"
                      checked={settings.cashDefault}
                      onChange={
                        [master, admin, support, owner].includes(Number(roleId))
                          ? handleCheckboxChange
                          : null
                      }
                    />
                    <span className="checkmark"></span>
                  </label>
                  <span>
                    {translator("TeantSettingTab-Checkbox-CashDefault")}
                  </span>
                </div>

                <div className="form-group col-12">
                  <label className="labelCont">
                    <input
                      type="checkbox"
                      name="closeArticleSearch"
                      checked={settings.closeArticleSearch}
                      onChange={
                        [master, admin, support, owner].includes(Number(roleId))
                          ? handleCheckboxChange
                          : null
                      }
                    />
                    <span className="checkmark"></span>
                  </label>
                  <span>
                    {translator("TeantSettingTab-Checkbox-CloseArticleSearch")}
                  </span>
                </div>

                <div className="form-group col-12">
                  <label className="labelCont">
                    <input
                      type="checkbox"
                      name="multiDraft"
                      checked={settings.multiDraft}
                      onChange={
                        [master, admin, support, owner].includes(Number(roleId))
                          ? handleCheckboxChange
                          : null
                      }
                    />
                    <span className="checkmark"></span>
                  </label>
                  <span>
                    {translator("TeantSettingTab-Checkbox-MultiDraft")}
                  </span>
                </div>

                <div className="form-group col-md-12">
                  <label>{translator("Gotovinski popust")}</label>
                  <div className="input-group" style={{ width: "150px" }}>
                    <input
                      type="number"
                      name="cashDiscount"
                      className="form-control"
                      ref={register({ max: 99, min: 0 })}
                      defaultValue={settings.cashDiscount}
                      onChange={
                        [master, admin, support, owner].includes(Number(roleId))
                          ? () => setDisable(false)
                          : null
                      }
                    />
                    <div className="input-group-append">
                      <span className="input-group-text" id="basic-addon2">
                        %
                      </span>
                    </div>
                  </div>

                  {errors.cashDiscount &&
                    errors.cashDiscount.type === "max" && (
                      <p className="text-danger">
                        {translator("Popust može biti najviše 99%.")}
                      </p>
                    )}
                  {errors.cashDiscount &&
                    errors.cashDiscount.type === "min" && (
                      <p className="text-danger">
                        {translator("Popust može biti samo pozitivan broj.")}
                      </p>
                    )}
                </div>
                <div className="form-group col-md-12">
                  <label>{translator("DataRetentionDays")}</label>
                  <div className="input-group" style={{ width: "150px" }}>
                    <input
                      style={{ width: "100px" }}
                      type="number"
                      name="dataRetentionDays"
                      className="form-control"
                      ref={register({ pattern: numbersOnly, max: 365, min: 1 })}
                      defaultValue={settings.dataRetentionDays}
                      onChange={
                        [master, admin, support, owner].includes(Number(roleId))
                          ? () => setDisable(false)
                          : null
                      }
                    />
                    <div className="input-group-append">
                      <span className="input-group-text" id="basic-addon2">
                        d
                      </span>
                    </div>
                  </div>

                  {errors.dataRetentionDays &&
                    errors.dataRetentionDays.type === "pattern" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-NumberOnly")}
                      </p>
                    )}
                  {errors.dataRetentionDays &&
                    errors.dataRetentionDays.type === "max" && (
                      <p className="text-danger">
                        {translator("ValidationMsg365Min")}
                      </p>
                    )}
                  {errors.dataRetentionDays &&
                    errors.dataRetentionDays.type === "min" && (
                      <p className="text-danger">
                        {translator("ValidationMsg365Min")}
                      </p>
                    )}
                </div>

                <div className="form-group col-12">
                  <label className="labelCont">
                    <input
                      type="checkbox"
                      name="useFiscalTip"
                      checked={settings.useFiscalTip}
                      onChange={
                        [master, admin, support, owner].includes(Number(roleId))
                          ? handleCheckboxChange
                          : null
                      }
                    />
                    <span className="checkmark"></span>
                  </label>
                  <span>
                    {translator("TeantSettingTab-Checkbox-FiscalTip")}
                  </span>
                </div>
                <div className="form-group col-md-12">
                  <label>{translator("Max broj artikala za easy mode")}</label>
                  <div className="input-group" style={{ width: "150px" }}>
                    <input
                      type="number"
                      name="maxProductNumber"
                      className="form-control"
                      ref={register({ max: 15, min: 1 })}
                      defaultValue={settings.maxProductNumber}
                      onChange={
                        [master, admin, support, owner].includes(Number(roleId))
                          ? () => setDisable(false)
                          : null
                      }
                    />
                    
                  </div>

                  {errors.maxProductNumber &&
                    errors.maxProductNumber.type === "max" && (
                      <p className="text-danger">
                        {translator("Broj može biti najviše 15.")}
                      </p>
                    )}
                  {errors.maxProductNumber &&
                    errors.maxProductNumber.type === "min" && (
                      <p className="text-danger">
                        {translator("Broj mora biti veći od O")}
                      </p>
                    )}
                </div>
               
              </fieldset>
            </div>
            <div className="col-lg-6">
              <fieldset className="scheduler-border">
                 <div className="form-group col-md-12">
                  <label>{translator("EDI-Api-Key")}</label>
                  <div className="input-group" >
                    <input
                      type="text"
                      name="ediApiKey"
                      className="form-control"
                      ref={register({ required:false  })}
                      defaultValue={settings.ediApiKey}
                      onChange={
                        [master, admin, support, owner].includes(Number(roleId))
                          ? () => setDisable(false)
                          : null
                      }
                    />
                   
                  </div>

                 
                </div>
                <div className="form-group col-md-12">
                  <label>{translator("EDI-Api-Password")}</label>
                  <div className="input-group" >
                    <input
                      type="text"
                      name="ediApiPassword"
                      className="form-control"
                      ref={register({required:false})}
                      defaultValue={settings.editApiPassword}
                      onChange={
                        [master, admin, support, owner].includes(Number(roleId))
                          ? () => setDisable(false)
                          : null
                      }
                    />
                   
                  </div>

                  
                </div>
               <div className="form-group col-md-12">
                  <label>{translator("DueDays")}</label>
                  <div className="input-group" style={{ width: "150px" }}>
                    <input
                      style={{ width: "100px" }}
                      type="number"
                      name="dueDays"
                      className="form-control"
                      ref={register({ pattern: numbersOnly, max: 365, min: 1 })}
                      defaultValue={settings.dueDays}
                      onChange={
                        [master, admin, support, owner].includes(Number(roleId))
                          ? () => setDisable(false)
                          : null
                      }
                    />
                    <div className="input-group-append">
                      <span className="input-group-text" id="basic-addon2">
                        d
                      </span>
                    </div>
                  </div>

                  {errors.dueDays &&
                    errors.dueDays.type === "pattern" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-NumberOnly")}
                      </p>
                    )}
                  {errors.dueDays &&
                    errors.dueDays.type === "max" && (
                      <p className="text-danger">
                        {translator("ValidationMsg365Min")}
                      </p>
                    )}
                  {errors.dueDays &&
                    errors.dueDays.type === "min" && (
                      <p className="text-danger">
                        {translator("ValidationMsg365Min")}
                      </p>
                    )}
                </div>
                
              </fieldset>
            </div>

            {[master, admin, support, owner].includes(Number(roleId)) && (
              <div
                className="container-fluid"
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                <button
                  disabled={isDisabled}
                  className="btn btn-primary"
                  type="submit"
                >
                  {translator("Btn-Save")}
                </button>
              </div>
            )}
          </form>
        </div>

        <ResultModal
          show={modal.show}
          title={modal.title}
          text={modal.text}
          btnClass={modal.btnClass}
          handleClose={handleClose}
        />
      </div>
    </div>
  );
};

export default TeantSettingTab;
